import { useNetwork } from '@/presentation/context/network';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import PoolIcon from '@/components/elements/PoolIcon';
import { LiquidityPool, VAULT_FEE_TIER, feeTierToPercentage } from 'nftx.js';
import FormattedEther from '../../elements/FormattedEther/FormattedEther';
import { useFormatter } from 'use-intl';
import Price from '../../elements/Price';

const PoolsTableItem = ({
  id,
  tokens,
  feeTier: fee,
  index,
  inRangeLiquidity,
  totalValueLocked,
  dailyVolume,
  weeklyVolume,
  vaultId,
  apr,
}: LiquidityPool & {
  index: number;
}) => {
  const { push } = useRouter();
  const { slug } = useNetwork();
  const { number } = useFormatter();

  return (
    <tr
      className="cursor-pointer hover:bg-gray-200 text-gray-800"
      onClick={() => push(`/${slug}/info/pools/${id}`)}
    >
      <td className="px-3 py-4">{index}</td>
      <td className="px-3 py-4">
        <Link
          href={`/${slug}/info/pools/${id}`}
          className="space-x-2 flex items-center"
        >
          <div className="flex w-12">
            <PoolIcon {...tokens[0]} vaultId={vaultId} />
            <PoolIcon {...tokens[1]} vaultId={vaultId} />
          </div>
          <span className="">
            {tokens
              .map((t) => (t.symbol === 'WETH' ? 'ETH' : t.symbol))
              .join('/')}
          </span>
          <span
            className={`py-1 px-1.5 rounded-md ${
              fee === VAULT_FEE_TIER
                ? 'bg-pink-500 text-gray-50'
                : 'bg-gray-300'
            } text-xs font-medium`}
          >
            {number(feeTierToPercentage(fee), {
              style: 'percent',
              minimumSignificantDigits: 1,
            })}
          </span>
        </Link>
      </td>
      <td className="px-3 py-4 text-right">
        {apr['1m'] ? (
          <FormattedEther
            value={apr['1m'] ?? 0n}
            style="percent"
            maximumFractionDigits={2}
          />
        ) : (
          '-'
        )}
      </td>
      <td className="px-3 py-4 text-right">
        <Price showEmpty value={totalValueLocked} />
      </td>
      <td className="px-3 py-4 text-right">
        <Price value={dailyVolume} showEmpty />
      </td>
      <td className="px-3 py-4 text-right">
        <Price value={weeklyVolume} showEmpty />
      </td>
      <td className="px-3 py-4 text-right">
        <FormattedEther
          value={inRangeLiquidity}
          style="percent"
          maximumFractionDigits={2}
        />
      </td>
    </tr>
  );
};

export default PoolsTableItem;
